


export const getRequiredEnviromentVariable = (name: string): string => {
    const variable = process.env[name];
    if (!variable) {
        throw new Error(`[env]: ${name} must be defined"`);
    };
    return variable
};

export const getBooleanEnviromentVariable = (name: string): boolean | undefined => {
    const variable = process.env[name];
    return variable ? variable === "true" : undefined
};



const BASE_URL = getRequiredEnviromentVariable("REACT_APP_API_BASE_URL");
export const bestGuessHostedInDevelopment = BASE_URL.indexOf("test") > -1 && BASE_URL.indexOf("prod") === -1;
